import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { FormBuilder } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {

  responseObj: any;
  successMessage: any;

  public modalRef: BsModalRef;
  // showLoadingWheel:boolean = true;
  // showLoadingWheels:boolean = false;
  loading = false;
  loader = false;
  loginUserObj: any = {};
  loginError= false;
  errorMessage: String = '';
  allUsers: any = [];
  manual: any;
  usersScreen = false;
  currentRecords: any = [];
  rowCountPerPage: any = 10;
  currentPage: any = 1;
  isEnableFirst  = false;
  isEnablePrevious = false;
  isEnableNext  = true;
  isEnableLast  = true;
  
  @ViewChild('togglecontent') toggle: any;
    // usersList:any = [];
  constructor(private router:Router, private http:AuthService, private route: ActivatedRoute, private authService:AuthService, private fb:FormBuilder, private modalService: BsModalService) { }

  getAllUsers(){
    this.http.getAllUsersApi().subscribe(res=>{
      // this.loading = false;
      //console.log(res);
      this.allUsers = res.responseObj;
    },
    error => { 
    // this.loading = false;
    });
  }

  updateStatus(id, status) {
    //console.log(id, '***', status);
    this.http.updateStatusApi(id, status).subscribe(res=>{
      //console.log(res);
      this.getAllUsers();
    },
    error => { 
      this.getAllUsers();
    });
  }

  toggleBtnClick() {
    //console.log("toggle click");
    const x = document.getElementById("togglecontent");
    x.click();
  } 

  ngOnInit() {
    this.getAllUsers();
  }

}




// WEBPACK FOOTER //
// ./src/app/user-management/users-list/users-list.component.ts